import { useTranslation } from 'react-i18next'

export default function Partners() {
  const { t } = useTranslation()
  return (
    <section className="relative py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-xs uppercase tracking-widest text-indigo-400 font-medium">{t('partners.headline')}</span>
          <h2 className="text-4xl md:text-5xl mt-3 mb-4">{t('partners.headline')}</h2>
          <p className="text-slate-200/80">{t('partners.subheadline')}</p>
        </div>

        <div className="flex justify-center">
          <div
            className="max-w-xl w-full rounded-2xl border border-white/15 p-8 flex flex-col sm:flex-row items-center sm:items-start gap-6"
            style={{ background: 'linear-gradient(145deg, rgba(43, 64, 118, 0.92), rgba(31, 49, 93, 0.88))' }}
          >
            {/* Jump Soft Logo */}
            <div className="shrink-0 flex items-center justify-center">
              <svg width="109" height="53" viewBox="0 0 109 53" fill="white" xmlns="http://www.w3.org/2000/svg" className="w-20 h-auto">
                <path d="M68.7494 1.628C54.6978 -2.75171 46.8508 6.73767 45.5734 14.1826C27.6585 7.81695 8.48785 9.00506 0.498779 10.5328C13.3297 35.7406 37.9089 36.2095 48.037 34.3846C44.4785 38.5819 38.2738 41.5558 33.7116 42.6508C44.3872 55.462 64.8259 56.0095 75.9577 42.7791C68.8406 40.863 64.1872 36.7029 61.8148 34.3846C87.4544 39.3118 104.517 21.1171 108.897 10.5328C90.1918 7.37638 72.1341 11.2968 63.8222 14.1826C63.1835 10.1678 63.9135 5.82523 68.7494 1.628Z"></path>
              </svg>
            </div>

            <div>
              <div className="flex items-center gap-2 mb-2">
                <a
                  href="https://www.jump-soft.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xl font-bold text-white hover:text-indigo-300 transition-colors"
                >
                  {t('partners.jumpsoft_name')}
                </a>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 text-slate-300/60">
                  <path fillRule="evenodd" d="M4.25 5.5a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 1 1.5 0v4A2.25 2.25 0 0 1 12.75 17h-8.5A2.25 2.25 0 0 1 2 14.75v-8.5A2.25 2.25 0 0 1 4.25 4h5a.75.75 0 0 1 0 1.5h-5Z" clipRule="evenodd" />
                  <path fillRule="evenodd" d="M6.194 12.753a.75.75 0 0 0 1.06.053L16.5 4.44v2.81a.75.75 0 0 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h2.553l-9.056 8.194a.75.75 0 0 0-.053 1.06Z" clipRule="evenodd" />
                </svg>
              </div>
              <p className="text-slate-100/80 text-sm leading-relaxed">
                {t('partners.jumpsoft_desc')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
